import React, { Component } from "react";
import axios from "axios";

const ConfirmationDialog = ({ show, onCancel, onConfirm, isDeleting, error }) => {
    const showHideClassName = show ? "modal display-block" : "modal display-none";

    return (
        <div className={showHideClassName}>
            <div className="modal-dialog">
                <div className="modal-dialog__header">
                    <h2 className="modal-dialog__title">
                        <i className="fas fa-exclamation-triangle" style={{ marginRight: "8px" }} />
                        Delete Account
                    </h2>
                </div>
                <div className="modal-dialog__body">
                    <div className="modal-dialog__warning">
                        <i className="fas fa-exclamation-circle modal-dialog__warning-icon" />
                        <strong>Warning:</strong> This action cannot be undone.
                    </div>
                    <p>
                        This will permanently delete your account and all associated data.
                        You won't be able to recover your account once it's deleted.
                    </p>
                    {error && (
                        <div className="modal-dialog__error">
                            <i className="fas fa-times-circle" style={{ marginRight: "8px" }} />
                            {error}
                        </div>
                    )}
                </div>
                <div className="modal-dialog__footer">
                    <button
                        className="button button--grey"
                        onClick={onCancel}
                        disabled={isDeleting}
                    >
                        Cancel
                    </button>
                    <button
                        className="button button--danger"
                        onClick={onConfirm}
                        disabled={isDeleting}
                    >
                        {isDeleting ? (
                            <span>
                                <i className="fas fa-spinner fa-spin" style={{ marginRight: "6px" }} />
                                Deleting...
                            </span>
                        ) : (
                            <span>
                                <i className="fas fa-trash-alt" style={{ marginRight: "6px" }} />
                                Delete account
                            </span>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

class DeleteAccount extends Component {
    state = {
        showConfirmation: false,
        isDeleting: false,
        error: null
    };

    handleDeleteClick = () => {
        this.setState({ showConfirmation: true, error: null });
    };

    handleCancel = () => {
        this.setState({ showConfirmation: false, error: null });
    };

    handleConfirm = () => {
        this.setState({ isDeleting: true, error: null });

        axios
            .delete("/api/v1/users/me", {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            })
            .then(() => {
                this.props.auth.logout();
            })
            .catch(error => {
                const errorMessage =
                    (error.response && error.response.data && error.response.data.message) ||
                    "Failed to delete account. Please try again.";
                this.setState({
                    isDeleting: false,
                    error: errorMessage
                });
            });
    };

    render() {
        return (
            <div className="center-placeholder">
                <h1 className="display-3 text-center">Delete Account</h1>
                <p className="lead text-center">
                    If you wish to delete your account, click the button below.
                </p>
                <div className="d-flex justify-content-center">
                    <button className="button button--danger" onClick={this.handleDeleteClick}>
                        Delete account
                    </button>
                </div>
                <ConfirmationDialog
                    show={this.state.showConfirmation}
                    onCancel={this.handleCancel}
                    onConfirm={this.handleConfirm}
                    isDeleting={this.state.isDeleting}
                    error={this.state.error}
                />
            </div>
        );
    }
}

export default DeleteAccount;
